import { c as _c } from "react/compiler-runtime";
import { VisaPriceTableResponse } from "@website/ticket-ui/visa/types";
type Detail = VisaPriceTableResponse["items"][number]["prices"][number]["detail"];
type TableProperties = {
  heading: string;
  tableData: Detail;
  passengerType: string;
};
export type TablesProperties = {
  priceTableData: VisaPriceTableResponse["items"];
};
const Table = t0 => {
  const $ = _c(21);
  const {
    heading,
    tableData,
    passengerType
  } = t0;
  const t1 = `${heading} ${passengerType || ""}`;
  let t2;
  if ($[0] !== t1) {
    t2 = <h5 className="text-subtitle-2 text-on-surface-high-emphasis mb-2">{t1}</h5>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== tableData) {
    t3 = tableData?.map?.(_temp);
    $[2] = tableData;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <tbody className="sm:hidden">{t3}</tbody>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== tableData) {
    t5 = tableData?.map?.(_temp2);
    $[6] = tableData;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <thead className="hidden sm:table-header-group"><tr>{t5}</tr></thead>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== tableData) {
    t7 = tableData?.map?.(_temp3);
    $[10] = tableData;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t7) {
    t8 = <tbody className="hidden sm:table-row-group"><tr>{t7}</tr></tbody>;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t4 || $[15] !== t6 || $[16] !== t8) {
    t9 = <table className="w-full table-fixed">{t4}{t6}{t8}</table>;
    $[14] = t4;
    $[15] = t6;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t2 || $[19] !== t9) {
    t10 = <div>{t2}{t9}</div>;
    $[18] = t2;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
};
export const Tables = t0 => {
  const $ = _c(4);
  const {
    priceTableData
  } = t0;
  let t1;
  if ($[0] !== priceTableData) {
    t1 = priceTableData?.map?.(_temp4);
    $[0] = priceTableData;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="flex flex-col gap-y-6 pt-3 md:pt-8">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
function _temp(item) {
  return <tr key={item.type}><td className="border-outline-thin bg-dim-background text-body-2 text-on-surface-high-emphasis h-9 w-6/12 border-y border-r px-4 py-2">{item.type}</td><td className="border-outline-thin text-body-2 text-on-surface-high-emphasis h-9 w-6/12 border-y border-l px-4 py-2 text-left">{item.price}</td></tr>;
}
function _temp2(item_0) {
  return <th className="border-outline-thin bg-dim-background text-body-2 text-on-surface-high-emphasis h-9 w-6/12 truncate border-y px-4 py-2 text-right first:border-r last:border-l" key={item_0.type} scope="col">{item_0.type}</th>;
}
function _temp3(item_1) {
  return <td className="border-outline-thin text-body-2 text-on-surface-high-emphasis h-9 w-6/12 border-y px-4 py-2 text-right first:border-r last:border-l" key={item_1.type}>{item_1.price}</td>;
}
function _temp4(item) {
  return <>{item.prices.map(priceItem => <Table heading={priceItem.title} key={item.passengerType} passengerType={item.passengerType} tableData={priceItem.detail} />)}</>;
}